import { Axios } from "axios-observable";
import { map, catchError, throwError } from "rxjs";
import { apiPathFn } from "@ntprsrf-frontend/common/src/utils/api";
import { ELOAAuditRequest, ELOATransactionRequest, ELOAListParams } from "../../requests/internet/eloa.request";
import { ELOAPaymentListResponse, ELOATransactionResponse, ELOACaseListResponse, ELOASingleListResponse, ELOAPendingAXSPaymentsListResponse, ELOAFetchStatusResponse  } from "../../responses/internet/eloa.response";
import { DOWNLOAD_CONFIG } from "@ntprsrf-frontend/common/src/utils/axios";
import { downloadFile } from "../../utils/handleResponse";

const apiPath = apiPathFn(import.meta.env.VITE_ELOA_SERVICE);

export function eloaInitiateFetch() {
    return Axios.post<ELOAFetchStatusResponse>(
        apiPath(["initiateFetch"])
    ).pipe(map((response) => response.data));
}

export function eloaFetchStatus(fetchId: string) {
    return Axios.get<ELOAFetchStatusResponse>(
        apiPath(["fetchStatus"]),
        {
            params: { fetchId }
        }
    ).pipe(map((response) => response.data));
}

export function eloaList(
    query: Partial<ELOAListParams>,
) {
    return Axios.get<ELOAPaymentListResponse>(
        apiPath(["list"]),
        {
            params: query,
        },
    ).pipe(map((res) => res.data));
}

export function eloaFirstCaseSelect(request: ELOAAuditRequest) {
    return Axios.post<ELOATransactionResponse>(
        apiPath(["firstCaseSelect"]),
        request,
    ).pipe(map((response) => response.data));
}

export function eloaContinue(request: ELOATransactionRequest) {
    return Axios.post<ELOACaseListResponse>(
        apiPath(["continue"]),
        request,
    ).pipe(
        map((response) => response.data),
        catchError((error) => {
            const { failedLocks, availableLocks } = error.response.data;

            return throwError(() => ({
                failedLocks,
                availableLocks
            }));
        })
    );
}

export function eloaClearAllCases() {
    return Axios.get<ELOATransactionResponse>(
        apiPath(["clearAllCases"]),
    ).pipe(map((res) => res.data));
}

export function eloaConfirm(request: ELOATransactionRequest) {
    return Axios.post<ELOAPaymentListResponse>(
        apiPath(["confirm"]),
        request,
    ).pipe(map((response) => response.data));
}

export function eloaAudit(request: ELOAAuditRequest) {
    return Axios.post<any>(
        apiPath(["audit"]),
        request,
    );
}

export function eloaLockedCases() {
    return Axios.get<ELOACaseListResponse>(
        apiPath(["getLockCases"]),
    ).pipe(map((res) => res.data));
}

export function eloaGetConfirmedCases() {
    return Axios.get<ELOACaseListResponse>(
        apiPath(["getConfirmedCases"]),
    ).pipe(map((res) => res.data));
}

export function eloaDownloadPaymentSummary() {
  return Axios.get<Blob>(
    apiPath([
      "download-payment-summary",
    ]),
    { 
      ...DOWNLOAD_CONFIG,
    },
  ).pipe(map(downloadFile));
}

export function eloaGetPendingAXSPayments(params: Partial<ELOAListParams>) {
    return Axios.get<ELOAPendingAXSPaymentsListResponse>(
        apiPath(["get-pending-axs"]),
        {
            params,
        }
    ).pipe(map((res) => res.data));
}
